import { useSelector } from 'react-redux';
import ModalsProvider from '../ModalsProvider';
import SectionBlock from '../../SectionBlock';
import sortByOrder from '../../utils/sortByOrder';
import { titlesMap } from './utils';
import kpiCardsStyles from '../../DashboardKPICards/dashboardKPICards.module.scss';

const LIST_CLASSNAMES = {
  mini_cards: kpiCardsStyles.dashboardKPICards,
};
const SECTION_TYPES = {
  mini_cards: 'kpicard',
};

const tabId = 'performance';

export default function PerformanceContent() {
  const { edition } = useSelector((state) => state.DashboardSlice);
  const tab = edition.tabs?.[tabId];

  const sections = (tab?.sections ?? [])
    .slice()
    .sort(sortByOrder)
    .map((section) => {
      const withTitle = section.id !== 'mini_cards';
      const listClassName = LIST_CLASSNAMES[section.id];
      const type = SECTION_TYPES[section.id] ?? 'card';

      const cards = (section.cards ?? []).slice().sort(sortByOrder);

      return {
        ...section,
        cards,
        title: titlesMap[section.id],
        props: { withTitle },
        listClassName,
        type,
      };
    });

  return (
    <ModalsProvider>
      {sections.map((section) => {
        const { id, title, cards, type, order, props, visible, listClassName } =
          section;

        return (
          <SectionBlock
            key={id}
            tabId={tabId}
            sectionId={id}
            title={title}
            cards={cards}
            order={order}
            type={type}
            titleProps={props}
            visible={visible}
            listClassName={listClassName}
          />
        );
      })}
    </ModalsProvider>
  );
}
